import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";


export default function FinancialDataEntriesBarChart({ stats }) {
    const data = [
        { name: "Companies", value: stats?.total_sheet_companies || 0 },
        { name: "Categories", value: stats?.total_categories || 0 },
        { name: "Units", value: stats?.total_units || 0 },
        { name: "Time period", value: stats?.total_timeframes || 0 },
    ];
    const colors = ["#B0C4DE", "#7A8FA6", "#B0C4DE", "#7A8FA6"];
    return (
        <div className="bg-white p-4 sm:p-6 rounded-xl shadow-md border">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg sm:text-xl font-bold">Financial Data Entries</h2>
                {/* <span className="text-xs sm:text-sm text-gray-600">This month</span> */}
            </div>

            <ResponsiveContainer width="100%" className="ml-[-45px]" height={210}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                    <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                    <Tooltip />
                    <Bar dataKey="value" radius={[6, 6, 0, 0]} barSize={70}>
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
